"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinksCarouselLayout = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LinksCarouselLayout = ({
  data,
  debug,
  modulePosition,
  className,
  renderOnMyPages
}) => {
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    title,
    linkItems
  } = data;
  const {
    getTestId
  } = (0, _testidGenerator.default)();

  /**
   * If there are 6 or fewer items, adjust the carousel width to fit them all exactly.
   * This prevents the last slide from being clipped when arrows are hidden.
   */
  const adjustedCarouselWidth = (0, _react.useMemo)(() => {
    if (linkItems.length === 0 || linkItems.length > 6) {
      return undefined;
    }
    const slideWidth = isMobile ? _presentationComponents.CATEGORY_BOX_MOBILE_WIDTH : _presentationComponents.CATEGORY_BOX_DESKTOP_WIDTH;
    const gap = isMobile ? _constants.CAROUSEL_MOBILE_GAP : _constants.CAROUSEL_DESKTOP_GAP;
    const slides = linkItems.length;
    const total = slides * slideWidth + (slides - 1) * gap;

    // Never exceed the viewport/wrapper width; keep exact width only when smaller
    return `min(${total}px, 100%)`;
  }, [linkItems.length, isMobile]);
  const carouselOptions = (0, _react.useMemo)(() => ({
    width: adjustedCarouselWidth,
    navigation: {
      position: 'outside',
      showArrows: !isMobile && linkItems.length > 6,
      size: 'medium'
    },
    pagination: {
      show: false
    },
    slider: {
      trimSpace: true,
      loop: false,
      slides: {
        perView: 'auto',
        spacing: isMobile ? _constants.CAROUSEL_MOBILE_GAP : _constants.CAROUSEL_DESKTOP_GAP
      }
    }
  }), [adjustedCarouselWidth, isMobile, linkItems.length]);
  if (linkItems.length < 1) {
    return (0, _utils.getModulesContentError)({
      debug,
      modulePosition,
      layout: 'EditorialLinkCarousel'
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.LINKS_CAROUSEL_ROOT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      variant: "h4",
      component: "h2",
      textAlign: "center",
      "data-testid": getTestId(_constants.LINKS_CAROUSEL_TITLE),
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselWrapper, {
      carouselWidth: adjustedCarouselWidth,
      renderOnMyPages: renderOnMyPages,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
        ...carouselOptions,
        id: _constants.LINKS_CAROUSEL_ID,
        children: linkItems.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
          minWidth: isMobile ? _presentationComponents.CATEGORY_BOX_MOBILE_WIDTH : _presentationComponents.CATEGORY_BOX_DESKTOP_WIDTH,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
            buttonText: translations.view,
            imageUrl: item.imageUrl,
            relativeUrl: item.link?.relativeUrl ?? '',
            title: item.title
          })
        }, item.title))
      })
    })]
  });
};
exports.LinksCarouselLayout = LinksCarouselLayout;
